export default {
  id: 'settings',
  title: 'Company Settings',
  category: 'Admin',
  summary: 'Configure company identity, tax tables, indirect rates, per diem rates, benefits, and related organization settings.',
  overview: 'Settings control company-wide defaults used across Timeclerk — branding, tax parameters, versioned indirect rate tables, DoD per diem imports, benefits definitions, and applicable degrees.',
  howItWorks: [
    'Company Settings manage logo, name, address, and contact information shown in the product.',
    'Tax Tables define rates such as Social Security, Medicare, FUTA, and SUI used in payroll-related calculations.',
    'Indirect Rates define fringe, overhead, G&A, and sub management percentages by effective period for direct labor costing on cost-plus contracts.',
    'Per Diem Rates let you upload DoD CONUS/OCONUS ASCII ZIP files, search locations for lodging/meals rates, and review import history. Travel expense location entry uses this data.',
    'Benefits Tables and Company Benefits define benefit structures available to employees.',
    'Applicable Degrees support employee qualification fields where used.'
  ],
  actions: [
    {
      name: 'Update company profile / logo',
      description: 'Changes the company identity used in the header and documents.'
    },
    {
      name: 'Edit tax tables',
      description: 'Updates statutory rate inputs used by payroll and costing features.'
    },
    {
      name: 'Manage indirect rates',
      description: 'Creates and maintains versioned indirect rate tables used by Direct Labor Rates on cost-plus contracts.'
    },
    {
      name: 'Upload & import per diem rates',
      description: 'Imports a DoD CONUS or OCONUS file. New rates become available for travel location lookups; import history records what was loaded.'
    },
    {
      name: 'Search per diem locations',
      description: 'Looks up lodging and meals rates by place so you can verify data after import.'
    },
    {
      name: 'Manage benefits',
      description: 'Maintains benefit definitions referenced from employee records and company benefits pages.'
    }
  ],
  tips: [
    'Import current fiscal-year DoD per diem files before employees build travel estimates that rely on location rates.',
    'Coordinate tax and indirect rate changes with open payroll or cost-plus rate periods.',
    'Logo updates may require a refresh before they appear everywhere.'
  ],
  related: ['company-benefits', 'contracts', 'travel-expense', 'employees', 'payroll']
};



// WEBPACK FOOTER //
// ./client/help/content/settings.js